// Shared by the announcement editor and the email renderer. The message is
// plain text with a deliberately small formatting vocabulary, never HTML.
const escapeHtml = value => String(value || '').replace(/[&<>"']/g, char => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
}[char]));

const colours = ['#8b1e32', '#1c5d73', '#426832', '#805716'];
const inline = value => escapeHtml(value)
  .replace(/\{\{color:(#[0-9a-fA-F]{6})\|([^{}\n]+)\}\}/g, (match, colour, content) =>
    colours.includes(colour.toLowerCase()) ? `<span style="color:${colour.toLowerCase()}">${content}</span>` : match)
  .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
  .replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');

const safeImageSource = source => /^(?:\/uploads\/books\/newsletter\/[a-f0-9-]{36}\.(?:png|jpg|webp|gif)|cid:deenlit-announcement-[1-3])$/i.test(source || '');
const imageHtml = (source, index) => `<img src="${escapeHtml(source)}" alt="Announcement image ${index + 1}" width="420" style="display:block;width:auto;max-width:100%;max-height:340px;height:auto;margin:0 auto 18px;border-radius:10px">`;

function formatAnnouncementHtml(value, imageSources = []) {
  const sources = Array.isArray(imageSources) ? imageSources : [];
  const lines = String(value || '').replace(/\r\n?/g, '\n').split('\n');
  const parts = [];
  const placedImages = new Set();
  let paragraph = [];
  let bullets = [];
  const flushParagraph = () => {
    if (paragraph.length) parts.push(`<p style="margin:0 0 16px;line-height:1.8">${paragraph.map(inline).join('<br>')}</p>`);
    paragraph = [];
  };
  const flushBullets = () => {
    if (bullets.length) parts.push(`<ul style="margin:0 0 16px;padding-left:24px;line-height:1.8">${bullets.map(item => `<li>${inline(item)}</li>`).join('')}</ul>`);
    bullets = [];
  };
  for (const line of lines) {
    if (!line.trim()) { flushParagraph(); flushBullets(); continue; }
    const image = line.match(/^\s*\{\{image:([1-3])\}\}\s*$/);
    if (image) {
      const index = Number(image[1]) - 1;
      if (safeImageSource(sources[index])) {
        flushParagraph(); flushBullets();
        parts.push(imageHtml(sources[index], index));
        placedImages.add(index);
        continue;
      }
    }
    const bullet = line.match(/^\s*[-•] (.+)$/);
    if (bullet) { flushParagraph(); bullets.push(bullet[1]); }
    else { flushBullets(); paragraph.push(line); }
  }
  flushParagraph(); flushBullets();
  sources.forEach((source, index) => {
    if (safeImageSource(source) && !placedImages.has(index)) parts.push(imageHtml(source, index));
  });
  return parts.join('') || '<p style="margin:0;line-height:1.8"></p>';
}

function formatAnnouncementText(value) {
  return String(value || '').replace(/^\s*\{\{image:[1-3]\}\}\s*$/gm, '[Image]')
    .replace(/\{\{color:#[0-9a-fA-F]{6}\|([^{}\n]+)\}\}/g, '$1')
    .replace(/\*\*([^*\n]+)\*\*/g, '$1').replace(/(^|[^*])\*([^*\n]+)\*/g, '$1$2');
}

module.exports = { colours, formatAnnouncementHtml, formatAnnouncementText };
